import React, { FC } from "react";
import { ErrorMessage } from "formik";
import {
  Autocomplete,
  AutocompleteChangeReason,
  Box,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";

import styles from "./FormDropdownField.module.scss";
interface IProps {
  title?: string;
  label: string;
  value: string;
  name: string;
  className?: string;
  options?: any[]; // if renderTags available then use as a string
  placeholder?: string;
  renderTags?: any;
  inputHandler: (fieldName: string, value?: any) => void;
  [x: string]: any;
}


const FormDropdownField: FC<IProps> = (props) => {
  const {
    title,
    label,
    value,
    name,
    className = "mg-b-50",
    inputHandler,
    placeholder,
    options = [],
    ...rest
  } = props;

  const onChange = (event: React.SyntheticEvent<Element, Event>, value: string, reason: AutocompleteChangeReason)=>{
    if(reason === 'clear'){
      inputHandler(name, '')
    }
    else inputHandler(name, value)
  }

  return (
    <Box className={className}>
      {title && (
        <Typography
          variant={"subtitle1"}
          component={"h3"}
          color={"secondary"}
          className={`mg-b-10 ${styles.leftDash}`}
        >
          {title}
        </Typography>
      )}

      <label className="form-label mg-b-20 font-size-14 font-weight-medium">
        {label}
      </label>

      <FormControl className={`form-control ${styles.heightAuto}`}>
        <Autocomplete
          freeSolo
          disablePortal
          value={value}
          options={options}
          onChange={onChange}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          {...rest}
          renderInput={(params) => (
            <TextField name={name} {...params} placeholder={placeholder} />
          )}
        />
        <ErrorMessage
          name={name}
          render={(msg) => (
            <span className="text-danger font-size-sm">{msg}</span>
          )}
        />
      </FormControl>
    </Box>
  );
};

export default FormDropdownField;
